import { UpdateIconButton, pn, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@compass/core";

import { ListBeProperty } from "components";
import { Permission, PermissionAction, ScholarshipPaymentMethodListDto, SortObject } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { ScholarshipTypeListResource } from "generated/openApi";
import { scholarshipPaymentMethodPageRoute } from "../ScholarshipPaymentMethodPage/ScholarshipPaymentMethodPage";

export const ScholarshipPaymentMethodTable = (props: {
    rootPermission: Permission;
    tableContainerRef: React.RefObject<HTMLDivElement>;
    scholarshipPaymentMethod: ScholarshipPaymentMethodListDto[];
    setScholarshipPaymentMethod: (scholarshipPaymentMethod: ScholarshipPaymentMethodListDto[]) => void;
    resource: ScholarshipTypeListResource;
    searchFocused: boolean;
    sortObjects: SortObject[] | undefined;
    sort: (sortObjects: SortObject[]) => void;
    loadList: () => void;
}) => {
    const navigate = useNavigate();
    const properties = props.resource.properties || [];

    return (
        <TableContainer ref={props.tableContainerRef}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: "7%"}}>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<ScholarshipPaymentMethodListDto>("id"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<ScholarshipPaymentMethodListDto>("name"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell type="action"></TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {props.scholarshipPaymentMethod.map((scholarshipPaymentMethodItem) => (
                        <TableRow
                            key={scholarshipPaymentMethodItem.id}
                            onClick={() =>
                                navigate(
                                    scholarshipPaymentMethodPageRoute.getPath({
                                        id: scholarshipPaymentMethodItem.id,
                                        crudMode: "view",
                                        screenType: "dialog"
                                    })
                                )
                            }
                        >
                            <TableCell>{scholarshipPaymentMethodItem.id}</TableCell>
                            <TableCell>{scholarshipPaymentMethodItem.name}</TableCell>
                            <TableCell type="action">
                                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                                    <UpdateIconButton color="primary"
                                        onClick={() =>
                                            navigate(
                                                scholarshipPaymentMethodPageRoute.getPath({
                                                    id: scholarshipPaymentMethodItem.id,
                                                    crudMode: "edit",
                                                    screenType: "dialog"
                                                })
                                            )
                                        }
                                    />
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
